import SEO from "Components/SEO";
import React from "react";
import { homeConfig } from "./config";
import Navbar from "Components/Navbar";

import "./style.scss";
import AboutHeader from "Components/AboutPage/AboutHeader/AboutHeader";
import OurMissionVision from "Components/AboutPage/OurMissionVision/OurMissionVision";
import WorldOfMetaverse from "Components/WorldOfMetaverse";
import WhoWeAre from "Components/AboutPage/WhoWeAre/WhoWeAre";
import LimitedTimeOffer from "Components/AboutPage/LimitedTimeOffer/LimitedTimeOffer";
import CoreValuesSection from "Components/AboutPage/CoreValuesSection/CoreValuesSection";
import JoinMovement from "Components/AboutPage/JoinMovement/JoinMovement";
import EarnAndEngageSection from "Components/AboutPage/EarnAndEngageSection/EarnAndEngageSection";

const AboutPage = () => {
    const { underConstruction, underConstructionMessage, SEO_DATA } =
        homeConfig;

    if (underConstruction) {
        return <h1>{underConstructionMessage}</h1>;
    }

    return (
        <div id={"about-page-wrapper"}>
            <SEO
                title={SEO_DATA.title}
                description={SEO_DATA.description}
                keywords={SEO_DATA.keywords}
            />

            <div style={{ position: "relative" }}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        zIndex: 10,
                    }}
                >
                    <Navbar />
                </div>
                <AboutHeader />
                <OurMissionVision />
                <WorldOfMetaverse />
                <WhoWeAre />
                <LimitedTimeOffer />
                <CoreValuesSection />
                <EarnAndEngageSection />
                <JoinMovement />
            </div>
        </div>
    );
};

export default AboutPage;
